/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalframe_Error_BodyInputs */

const en_portalframe_error_body = /** @type {(inputs: Portalframe_Error_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check your connection and try again. If it keeps happening, message your team.`)
};

/** @type {(inputs: Portalframe_Error_BodyInputs) => LocalizedString} */
const ar_portalframe_error_body = en_portalframe_error_body;

/** @type {(inputs: Portalframe_Error_BodyInputs) => LocalizedString} */
const he_portalframe_error_body = en_portalframe_error_body;

/** @type {(inputs: Portalframe_Error_BodyInputs) => LocalizedString} */
const ur_portalframe_error_body = en_portalframe_error_body;

/** @type {(inputs: Portalframe_Error_BodyInputs) => LocalizedString} */
const es_portalframe_error_body = en_portalframe_error_body;

/** @type {(inputs: Portalframe_Error_BodyInputs) => LocalizedString} */
const fr_portalframe_error_body = en_portalframe_error_body;

/** @type {(inputs: Portalframe_Error_BodyInputs) => LocalizedString} */
const de_portalframe_error_body = en_portalframe_error_body;

/** @type {(inputs: Portalframe_Error_BodyInputs) => LocalizedString} */
const pt_portalframe_error_body = en_portalframe_error_body;

/** @type {(inputs: Portalframe_Error_BodyInputs) => LocalizedString} */
const hi_portalframe_error_body = en_portalframe_error_body;

/** @type {(inputs: Portalframe_Error_BodyInputs) => LocalizedString} */
const bn_portalframe_error_body = en_portalframe_error_body;

/**
* | output |
* | --- |
* | "Check your connection and try again. If it keeps happening, message your team." |
*
* @param {Portalframe_Error_BodyInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalframe_error_body = /** @type {((inputs?: Portalframe_Error_BodyInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalframe_Error_BodyInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalframe_error_body(inputs)
	if (locale === "he") return he_portalframe_error_body(inputs)
	if (locale === "ur") return ur_portalframe_error_body(inputs)
	if (locale === "es") return es_portalframe_error_body(inputs)
	if (locale === "fr") return fr_portalframe_error_body(inputs)
	if (locale === "de") return de_portalframe_error_body(inputs)
	if (locale === "pt") return pt_portalframe_error_body(inputs)
	if (locale === "hi") return hi_portalframe_error_body(inputs)
	if (locale === "bn") return bn_portalframe_error_body(inputs)
	return /** @type {LocalizedString} */ ("Check your connection and try again. If it keeps happening, message your team.")
});